import BaseDisclosureController from '../base-disclosure.controller';

class ConflictOfInterestController extends BaseDisclosureController {
    constructor(_, preFetchedData, componentRegistryService, componentDataService, disclosureService, loggerService, $location, $state, $q, constants, fileSaver) {
        super(_,
            $location,
            $state,
            $q,
            'conflictOfInterestController',
            constants.DisclosureType.Conflict,
            "/.coi.conflictofinterestreview",
            preFetchedData,
            componentDataService,
            componentRegistryService,
            disclosureService,
            fileSaver,
            loggerService);
        this.conflictCategories = preFetchedData.conflictCategories;
        this.lineManagers = preFetchedData.lineManagers;
        this.primaryLineManager = preFetchedData.primaryLineManager;
        this.employmentOptions = preFetchedData.employmentOptions;
        this.hasAlternativeOfficer = !this._.isEmpty(preFetchedData.alternativeOfficer) && !this._.isEmpty(preFetchedData.alternativeOfficer.fullName);    

        this._getComponent = (name) => this.componentRegistryService.get(name);
        this._getCurtinId = (component) => this._.get(component, "curtinId") || this._.get(component, "model.curtinId") || null;
        this._isAssessorError = (curtinId, assessorId) => curtinId && assessorId && curtinId.toUpperCase() === assessorId.toUpperCase() ?
            "The staff member you are in conflict with cannot be the assessor for your disclosure." : null;

        this.validateResponsibleOfficer = (curtinId) => this._isAssessorError(curtinId, this._getCurtinId(this._getComponent('closePersonalRelationshipWith')));

        this.validateConflictUser = (curtinId) => this._isAssessorError(curtinId, 
            this._getCurtinId(this._getComponent('alternativeOfficer')) || this._getCurtinId(this._getComponent('selectedManager')));            
        this.disableROChange = this.disclosureData.status === 'Amending';

        this.foreignInterferenceCategorySelected = null;
        this.conflictCategoryChanged();
    }

    conflictCategoryChanged() {
        let conflictCategory = this._getComponent('conflictCategory');
        if (conflictCategory != null && conflictCategory.model != null && conflictCategory.model.id != null) {
            this.foreignInterferenceCategorySelected = conflictCategory.model.id === "ForeignInterference";
        }
        else {
            this.foreignInterferenceCategorySelected = null;
        }
    }
}

ConflictOfInterestController.$inject = ['_', 'preFetchedData', 'componentRegistryService', 'componentDataService', 'disclosureService', 'loggerService', '$location', '$state', '$q', 'constants', 'FileSaver'];

export default ConflictOfInterestController;


// WEBPACK FOOTER //
// ./app/disclose/conflictOfInterest/conflictOfInterest.controller.js